/*
 * @Author: Zhouqi
 * @Date: 2025-11-03 19:40:27
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09
 */
import dynamic from 'next/dynamic';

import VideoEditSkeleton from '@/3.0/ai-video-edit/_components/video-edit-skeleton';
import DelayedRender from '@/components/DelayRender';
import { withLayout } from '@/utils/withLayout';

const VideoEdit = dynamic(() => import('@/3.0/ai-video-edit/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <VideoEditSkeleton />
    </DelayedRender>
  ),
});

const VideoEditPage: React.FC = () => {
  return (
    <>
      {/* 功能页，勿动 */}
      <VideoEdit />
    </>
  );
};

export default withLayout(VideoEditPage);
